import { createContext } from 'react';

export interface AppBarInternalContextShape {
  isProd: boolean;
}

export const appBarInternalProdDefault = false;

const defaultValue: AppBarInternalContextShape = {
  isProd: appBarInternalProdDefault,
};

const AppBarInternalContext = createContext(defaultValue);

export default AppBarInternalContext;
